import { type IPendingTransaction } from '@recargas-dominicanas/core/types/pendingTransaction.type';
import { formatCurrency, formatDate } from '@recargas-dominicanas/core/utils';
import { DetailItem } from '@recargas-dominicanas/core/components';
import { Modal } from '../../../../components/modal/modal.component';
import { style } from './pending-transaction-modal.module.css';

interface Props {
  open: boolean;
  pendingTransaction: IPendingTransaction;
  onClose: () => void;
}

export function PendingTransactionModal(props: Props) {

  const {
    open,
    pendingTransaction,
    onClose
  } = props;

  return (
    <Modal
      open={open}
      style={style.modal}
      title='Transacción'
      onClose={onClose}>
      <DetailItem
        style={style.detailItem}
        title='Tipo'
        text={pendingTransaction.type === 'deposit' ? 'Deposito' : 'Retiro'}/>
      <DetailItem
        style={style.detailItem}
        title='Monto'
        color='green'
        weight='medium'
        text={formatCurrency(pendingTransaction.balance)}/>      
      <DetailItem
        style={style.detailItem}
        title='Fecha'
        text={formatDate(pendingTransaction.date)}/>
      <DetailItem
        style={style.detailItem}
        title='Fecha de creación'
        text={formatDate(pendingTransaction.creationDate)}/>      
      <DetailItem
        style={style.detailItem}
        title='Estado'
        color={pendingTransaction.status === 'registered' ? 'green' : undefined}
        weight='medium'
        text={pendingTransaction.status === 'registered' ? 'Registrado' : 'No registrado'}/>
      {pendingTransaction.reference &&
        <DetailItem
          style={style.detailItem}
          title='Referencia'
          text={pendingTransaction.reference}/>      
      }      
      {pendingTransaction.description &&
        <DetailItem
          style={style.detailItem}
          title='Descripción'
          text={pendingTransaction.description}/>      
      }     
    </Modal>
  );
}
